import React from 'react'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'

import {
  QuizDispatchContext,
  QuizStoreContext,
} from '../../contexts/quizContext'

import { T, O } from '../../utils/Typography'
import RadioItem from './RadioItem'
import { OptionId, optionsDict } from '../../data/options'
import CheckboxGroup from './CheckboxGroup'
import { styled } from '@mui/material/styles'
import FormControlUnstyled, {
  FormControlUnstyledProps,
} from '@mui/core/FormControlUnstyled'
import Radio from '@mui/material/Radio'

type TextQuestionFormProps = FormControlUnstyledProps & {}

type RadioQuestionProps = {
  currentQuizIndex: number
  questionText: string
  options: Array<OptionId>
  minSelections: number
  maxSelections: number
}

const RadioQuestion: React.FC<RadioQuestionProps> = React.memo(
  ({
    currentQuizIndex,
    questionText: label,
    options,
    minSelections,
    maxSelections,
  }) => {
    const { quizAnswers } = React.useContext(QuizStoreContext)
    const reduceQuizData = React.useContext(QuizDispatchContext)
    const questionAnswers = quizAnswers[currentQuizIndex]
    const value: OptionId = Object.keys(questionAnswers).reduce(
      (a, key) => (questionAnswers[key as OptionId] ? key : a),
      'test',
    ) as OptionId
    const isRadio = maxSelections === 1

    // React.useEffect(() => {
    //   console.log('value', value)
    // }, [value])

    // React.useEffect(() => {
    //   console.log('quizAnswers', quizAnswers)
    // }, [quizAnswers])

    const handleChange = React.useCallback(
      ({ option, checked }: { option: OptionId; checked?: boolean }) => {
        // console.log('handleChange', option, checked)
        if (isRadio) {
          reduceQuizData({
            type: 'update_quiz_answers_via_toggle',
            payload: {
              currentQuizIndex: currentQuizIndex,
              key: option,
            },
          })
        } else {
          reduceQuizData({
            type: 'update_quiz_answers',
            payload: {
              currentQuizIndex: currentQuizIndex,
              key: option,
              value: checked ?? false,
            },
          })
        }
      },
      [currentQuizIndex, reduceQuizData, isRadio],
    )

    return (
      <TextQuestionForm className='Quiz-form-control'>
        <FormLabel>
          <div style={{ textAlign: 'center', display: 'block' }}>
            <T variant='h4' style={{ marginBottom: 5 }}>{`${
              currentQuizIndex + 1
            }. ${label}`}</T>
            <T variant='h4' style={{ marginBottom: 20, fontSize: '1.2rem' }}>
              <O>{isRadio ? '(Choose one)' : '(Choose one or more)'}</O>
            </T>
            <br />
          </div>
        </FormLabel>
        {isRadio ? (
          <RadioGroup
            aria-label={label}
            name={label}
            value={value}
            onChange={(e) =>
              handleChange({
                option: e.target.value as OptionId,
              })
            }>
            {options.map((option, index) => {
              if (optionsDict[option] === undefined) {
                throw new Error(
                  `optionsDict is undefined for option: ${option}`,
                )
              }
              return (
                <FormControlLabel
                  key={index}
                  value={optionsDict[option]!.id}
                  control={<Radio />}
                  label={optionsDict[option]!.content}
                />
              )
            })}
          </RadioGroup>
        ) : (
          <CheckboxGroup options={options} handleChange={handleChange} />
        )}
      </TextQuestionForm>
    )
  },
)

const TextQuestionForm = styled(FormControlUnstyled, {
  shouldForwardProp: (prop) => true,
})<TextQuestionFormProps>(({ theme }) => ({
  // position: 'relative',
  // height: '100%',
  // borderWidth: 5,
  // borderStyle: 'solid',
  // borderRadius: 10,
  // [theme.breakpoints.down('sm')]: {
  //   width: '100% !important', // Overrides inline-style
  //   height: 100,
  // },
  '& .MuiTypography-root': {
    color: '#000',
  },
  '& .MuiSvgIcon-root': {
    color: '#f271b8',
  },
  '& .MuiButtonBase-root, & .MuiCheckbox-root': {
    '&:hover': {
      backgroundColor: '#f271b80a',
    },
    '& .MuiTouchRipple-root': {
      color: '#f271b8',
    },
  },
  '&:hover, &.Mui-focusVisible': {
    zIndex: 1,
    '& .MuiImageBackdrop-root': {
      opacity: 0.15,
    },
    '& .MuiImageMarked-root': {
      opacity: 0,
    },
    '& .MuiTypography-root': {
      // border: '4px solid currentColor',
    },
  },
}))

export default RadioQuestion
